export default __webpack_public_path__ + "static/media/Padron_5000Open.0c927c86.jpg";